import { REQUIRED_FIELD_MESSAGE, ERROR_PHONE_MESSAGE } from '@shared/constants/errorMessages';
import { emailValidator } from '@pages/event/lib/validator';

export interface MainGuestSimpleFields {
  lastName: string;
  firstName: string;
  patronymic: string;
  phone: string;
  email: string;
}

export interface MainGuestSimpleErrors {
  lastName?: string;
  firstName?: string;
  patronymic?: string;
  phone?: string;
  email?: string;
}

export const validateMainGuestSimple = async (fields: MainGuestSimpleFields): Promise<MainGuestSimpleErrors> => {
  const errors: MainGuestSimpleErrors = {};

  if (!fields.lastName?.trim()) errors.lastName = REQUIRED_FIELD_MESSAGE;
  if (!fields.firstName?.trim()) errors.firstName = REQUIRED_FIELD_MESSAGE;
  if (!fields.patronymic?.trim()) errors.patronymic = REQUIRED_FIELD_MESSAGE;
  const phoneDigits = fields.phone?.replace(/\D/g, '') ?? '';
  if (!fields.phone?.trim()) {
    errors.phone = REQUIRED_FIELD_MESSAGE;
  } else if (phoneDigits.length < 10) {
    errors.phone = ERROR_PHONE_MESSAGE;
  }
  if (!fields.email?.trim()) {
    errors.email = REQUIRED_FIELD_MESSAGE;
  } else {
    const emailError = await emailValidator(fields.email);
    if (emailError) errors.email = typeof emailError === 'string' ? emailError : REQUIRED_FIELD_MESSAGE;
  }

  return errors;
};

export const buildMainGuestOnlySubmissionInfo = (fields: MainGuestSimpleFields): string => {
  const mainGuest: Record<string, string> = {
    lastName: fields.lastName?.trim() ?? '',
    firstName: fields.firstName?.trim() ?? '',
    surname: fields.patronymic?.trim() ?? '',
    phone: fields.phone?.trim() ?? '',
    email: fields.email?.trim() ?? '',
  };
  return JSON.stringify({
    mainGuest,
    adultGuests: [],
    childrenGuests: [],
  });
};
